<template>
  <div class="indexWrap">
    <!--头部栏 开始-->
    <header class="topWrap">
      <!--顶部栏 左侧-->
      <div class="dsf">
        <!--logo 开始-->
        <div class="topLogo">
          <img class="topLogo-img" :src="require('@/assets/logo/logoa.png')" />
          <!-- <div class="topLogoText">升达云ERP</div> -->
        </div>
        <!--logo 结束-->
        <!--应用名称 开始-->
        <!-- <div class="appName">
          <el-dropdown placement="bottom">
            <span class="appSelected">
              <i class="hx hx-hx_yingyongfenleiqita appNameIcon"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>我的应用</el-dropdown-item>
              <el-dropdown-item
                v-for="(item,index) in config.application"
                :key="index"
                :divided="item.divided"
              >
                <div class="appItem" @click="gotoApplication(item.url)">
                  <i :class="item.icon" class="appItem-icon" v-if="item.icon"></i>
                  <div>{{item.title}}</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>-->
        <!--应用名称 结束-->
        <!--当前项目名称-->
        <div class="currentProjectName">
          <div class="el-icon-help Staffmembe">
            到期时间 : {{ Expire }}
            <span style="margin-left: 40px">账号数量 : {{ versioninfog }}</span>
          </div>
          <!-- <div class="Staffmembe" "></div> -->
        </div>
      </div>

      <!--顶部栏 右侧-->
      <div class="dsf">
        <!--客户公司名称-->
        <div class="projectName">{{ Enterprise }}</div>
        <div
          class="projectName"
          style="color: #53a9ff; padding: 0 10px"
          @click="Signout"
        >
          手机后台
        </div>
        <!--用户信息-->
        <div class="userInfoWrap">
          <div class="userInfo">
            <el-dropdown placement="bottom">
              <span class="mr10 dsf aic">
                <!-- @/assets/Images/default.jpg alt="@/assets/" -->
                <img
                  :src="
                    companyinfo == ''
                      ? require('@/assets/logo/itmee.png')
                      : companyinfo
                  "
                  class="avatar"
                  alt
                />
                {{ member }}
                <i class="el-icon-arrow-down ml10"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item>修改密码</el-dropdown-item>
                <el-dropdown-item>基本信息</el-dropdown-item>
                <el-dropdown-item>手机号绑定/解绑</el-dropdown-item>
                <el-dropdown-item>操作日志</el-dropdown-item>-->
                <!-- <el-dropdown-item>{{LocationProvince}}</el-dropdown-item>
                <el-dropdown-item>{{LocationCity}}</el-dropdown-item>-->
                <el-dropdown-item>
                  <div @click="SignoutClick">退出系统</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="home_box" v-if="IfShow">
        <span class="span">距离 {{ times }} 天后过期</span>
        <i class="el-icon-close i" @click="IFSGOWclick"></i>
      </div>
    </header>
    <!--头部栏 结束-->

    <!--主框架 开始-->
    <div class="middleWrap">
      <!--左侧 开始-->
      <!-- <transition name="left">
      <aside class="left" v-if="showMenu && !fullScreen">-->
      <!--搜索和收藏 开始-->
      <!-- <header class="searchAndFavor">
        <el-input placeholder="请输入内容" size="mini" v-model="searchText">
          <i class="el-icon-search searchiIcon" slot="suffix"></i>
      </el-input>-->
      <!-- 收藏夹 -->
      <!-- <div class="myFavor">
              <el-dropdown placement="bottom">
                <i class="el-icon-star-on myFavorIcon"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item disabled>收藏夹</el-dropdown-item>

                  <el-dropdown-item
                    v-for="(item,index) in config.favor"
                    :key="index"
                    :divided="index === 0"
                  >
                    <span @click="openTab(item)">{{item.title}}</span>
                    <i class="el-icon-close ml10" @click="removeCollect(item)"></i>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
      </div>-->
      <!-- </header> -->
      <!-- 搜索和收藏 结束 -->

      <!--左侧主菜单 开始-->
      <!-- <div class="content_box">
            <el-menu
              v-if="ifshow"
              :default-active="currentTabIndex"
              unique-opened
              :default-openeds="spreadedMenus"
            >
              <el-submenu v-for="(item,index) in menuList" :key="index" :index="item.menuId">
                <template slot="title">
                  <img class="jinxiaocun" src="@/assets/iconfont/jinxiaocun.png" alt />
                  <span>{{item.title}}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    v-for="(subItem,subIndex) in item.sub"
                    :key="subIndex"
                    @click="openTab(subItem)"
                    :index="subItem.menuId"
                  >
                    <img class="jinxiaocun" src="@/assets/iconfont/jinxiaocun.png" alt />
                    <el-dropdown placement="right-start" :trigger="triggerclick" >
                      <span
                        class="mr10 dsf aic cfff mouseover"
                        @mouseover="mouseover(subItem.title)"
                      >{{subItem.title}}</span>
                      <el-dropdown-menu slot="dropdown">
                        <div class="Navigation">
                          <div class="Navigation_box">
                            <div
                              class="list_line_style mtb20"
                              v-for="(val,index) in MaterialData"
                              :key="index"
                            >
                              <ul class="list-item-box">
                                <li>
                                  <img class="jinxiaocunclick" src="@/assets/logo/logo02.png" alt />
                                </li>
                                <li
                                  class="list_item"
                                  v-for="(obj,index) in val.textlist"
                                  :key="index"
                                  @click="open(obj)"
                                >
                                  <div class="right_box ub-f1 ub ub-ver ub-pj">
                                    <el-dropdown-item
                                      :class="primary==true?'item-title':''"
                                      class="item-titles"
                                    >{{obj.title}}</el-dropdown-item>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </el-menu>
      </div>-->

      <!-- <footer class="footer">
            <div class="el-icon-time footer-box">登录时间 :{{ time | formatDate }}</div>
      </footer>-->
      <!--左侧主菜单 结束-->
      <!-- </aside>
      </transition>-->
      <!--左侧 结束-->

      <!--  以上是旧版本的菜单  -->
      <!-- 左侧新菜单开始 -->
      <div name="left">
        <div class="left_menus"></div>
        <div
          :class="titleIfShow == true ? 'left_menu_hover' : ''"
          class="left_menu"
          @mouseover="mouseovershow"
          @mouseout="mousemove"
        >
          <el-menu
            v-if="ifshow"
            :default-active="currentTabIndex"
            unique-opened
            :default-openeds="spreadedMenus"
          >
            <el-submenu
              v-for="(item, index) in menuList"
              :key="index"
              :index="item.menuId"
            >
              <template slot="title">
                <img
                  class="jinxiaocun_left_menu"
                  src="@/assets/iconfont/jinxiaocun.png"
                  alt
                />
                <span class="titleIfShow_left_menu" v-show="titleIfShow">{{
                  item.title
                }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  v-for="(subItem, subIndex) in item.sub"
                  :key="subIndex"
                  @click="openTab(subItem)"
                  :index="subItem.menuId"
                >
                  <el-dropdown
                    placement="right-start"
                    size="small"
                    :trigger="triggerclick"
                  >
                    <span
                      class="mr10 dsf aic cfff mouseover_left_menu"
                      @mouseover="mouseover(subItem.title)"
                      v-show="titleIfShow"
                    >
                      <img
                        class="jinxiaocun_left_menu12"
                        :src="require('../../assets/lefticon/' + subItem.img)"
                        alt
                      />
                      {{ subItem.title }}
                    </span>
                    <img
                      v-show="!titleIfShow"
                      class="jinxiaocun_left_menu123"
                      :src="require('../../assets/lefticon/' + subItem.img)"
                      alt
                    />
                    <el-dropdown-menu slot="dropdown">
                      <div
                        class="Navigation"
                        @mouseover="mouseovershow"
                        @mouseout="mousemove"
                      >
                        <div class="Navigation_box">
                          <div
                            class="list_line_style"
                            v-for="(val, index) in MaterialData"
                            :key="index"
                          >
                            <ul class="list-item-box">
                              <li>
                                <img
                                  class="jinxiaocunclick"
                                  :src="
                                    require('../../assets/lefticon/icon2/' +
                                      val.img)
                                  "
                                  alt
                                />
                              </li>
                              <li
                                class="list_item"
                                v-for="(obj, index) in val.textlist"
                                :key="index"
                                @click="open(obj)"
                              >
                                <div class="right_box ub-f1 ub ub-ver ub-pj">
                                  <el-dropdown-item
                                    :class="primary == true ? 'item-title' : ''"
                                    class="item-titles"
                                    >{{ obj.title }}</el-dropdown-item
                                  >
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <!-- 左侧新菜单结束 -->
      <!--左侧 隐藏菜单按钮 开始-->
      <!-- <transition name="hideMenu">
        <div class="hideMenuButton" v-if="showMenu && !fullScreen" @click="showHideMenu(false)">
          <i class="el-icon-arrow-left"></i>
        </div>
      </transition>-->
      <!--左侧 隐藏菜单按钮 结束-->

      <!--左侧 显示菜单按钮 开始-->
      <!-- <transition name="showMenu">
        <div class="showMenuButton" v-if="!showMenu && !fullScreen" @click="showHideMenu(true)">
          <i class="el-icon-arrow-right"></i>
        </div>
      </transition>-->
      <!--左侧 显示菜单按钮 结束-->

      <!--右侧 开始-->
      <div :class="fullScreen ? 'fullRight' : 'right'" ref="right">
        <!--打开的菜单(tab-bar) 开始-->
        <div class="tabWrap">
          <div class="tabBar">
            <el-tabs
              :value="currentTabIndex"
              @input="$tab.showTab"
              @tab-remove="$tab.close"
              type="card"
            >
              <el-tab-pane
                v-for="item in openedTabs"
                :key="item.menuId"
                :label="item.title"
                :name="item.menuId"
                :closable="item.menuId !== homeTabMenuId"
              >
                <el-dropdown slot="label" placement="bottom">
                  <span>
                    <i
                      v-if="item.menuId === homeTabMenuId"
                      class="hx hx-hx_zhuye tabIcon"
                    ></i>
                    <div v-else>{{ item.title }}</div>
                  </span>

                  <el-dropdown-menu
                    slot="dropdown"
                    class="elDropdownMenu"
                    :class="{ hiddenDropDown: item.menuId !== currentTabIndex }"
                  >
                    <el-dropdown-item class="elDropdownItem">
                      <div class="tabDropdown">
                        <div
                          class="tabDropdownRefresh"
                          @click="reFreshTab(item)"
                        >
                          <i class="hx hx-hx_xshuaxin"></i> 刷新
                        </div>
                        <div class="tabDropdownLine"></div>
                        <!-- <div class="tabDropdownFavor" @click="addCollect(item)">
                          <i class="hx hx-hx_xshoucang"></i> 收藏
                        </div>-->
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <div class="content">
                  <component
                    :is="item.components[item.components.length - 1].path"
                    v-if="item.components.length"
                  ></component>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="tabOperate">
            <el-dropdown trigger="click" placement="bottom-start">
              <!--<i class="el-icon-tickets"></i>-->
              <i class="hx hx-hx_gengduogongneng"></i>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="exitFullScreen" v-if="fullScreen">退出全屏</el-dropdown-item>
                <el-dropdown-item @click.native="enterFullScreen" v-else>全屏</el-dropdown-item>-->
                <el-dropdown-item @click.native="$tab.closeAll"
                  >关闭全部</el-dropdown-item
                >
                <el-dropdown-item @click.native="$tab.closeOthers"
                  >关闭其他标签</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!--打开的菜单(tab-bar) 结束-->
        <!--<Router-Views></Router-Views>-->
      </div>

      <!--右侧 结束-->
      <!-- 盘点单弹框 -->

      <InvenTory :show.sync="addIfShows" />
    </div>
    <!--主框架 结束-->
  </div>
</template>
<script>
// import BMap from "BMap";
import config from "@/config/MainConf";
import tool from "@/utils/tool.js";
import { formatDate } from "@/utils/time";
import { Base64 } from "js-base64";
import store from "../../Store/index";
export default {
  data() {
    return {
      LocationProvince: "正在定位所在省", //给渲染层定义一个初始值
      LocationCity: "正在定位所在市", //给渲染层定义一个初始值
      isCollapse: true,
      titleIfShow: false,
      logo: "logo01.png",
      triggerclick: "hover", //  click
      primary: true,
      ifshow: true,
      config: config, // 全局配置
      showMenu: true, // 是否显示左侧菜单
      fullScreen: false, // 是否全屏
      searchText: "", // 搜索框里的文字
      menuList: [], // 复制一份菜单列表
      spreadedMenus: ["0-1"], // 要展开的菜单列表
      time: tool.getSession("times"), // 登陆时间
      member: tool.getLocal("FullName"), //"请登录", // 当前职员
      Enterprise: "请注册企业信息", // 企业名称
      companyinfo: "", // 企业头像
      times: "",
      IfShow: true,
      Mode: [
        {
          title: "销售管理",
          component: "SaleModel",
        },
        {
          title: "仓库管理",
          component: "Warehouse",
        },
        {
          title: "采购管理",
          component: "Procurement",
        },
        {
          title: "资金管理",
          component: "MoneyModule",
        },
        {
          title: "报表管理",
          component: "ReportModel",
        },
        {
          title: "基础资料",
          component: "material",
        },
        {
          title: "系统设置",
          component: "Setup",
        },
      ],
      SaleModel: [], //销售
      Warehouse: [], //仓库
      Procurement: [], //采购
      MoneyModule: [], //资金
      ReportModel: [], //报表
      material: [], //资料
      Setup: [], //设置
      MaterialData: [],
      addIfShows: false,
      Materia: "",
      Expire: "", //  到期时间
      versioninfog: "",
      timer: null,
    };
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  computed: {
    city() {
      //定义获取城市方法
      const geolocation = new BMap.Geolocation();
      var _this = this;
      geolocation.getCurrentPosition(
        function getinfo(position) {
          let city = position.address.city; //获取城市信息
          let province = position.address.province; //获取省份信息
          _this.LocationProvince = province;
          _this.LocationCity = city;
        },
        function (e) {
          _this.LocationCity = "定位失败";
        },
        { provider: "baidu" }
      );
    },
    // 当前 tab 项的 name
    currentTabIndex() {
      return this.$store.getters.GetCurrentTabIndex;
    },
    // 打开的页签列表
    openedTabs() {
      return this.$store.getters.GetOpenedTabs;
    },
    // 主页 tab 的 menuId
    homeTabMenuId() {
      return this.$store.getters.GetHomeTabMenuId;
    },
  },
  watch: {
    searchText() {
      this.filterMenu();
    },
  },
  methods: {
    mouseovershow(val) {
      // setTimeout(() => {}, 100);
      this.titleIfShow = true;
    },
    mousemove(val) {
      // setTimeout(() => {
      this.titleIfShow = false;
      // }, 100);
    },
    // 打开页面
    open(item) {
      // console.log(item);

      if (item.component == "inventory") {
        this.addIfShows = true;
      } else {
        item.menuId = item.menuId + "-vIp";
        this.$tab.push(item, { VchCode: 0, dist: 0 });
      }
    },
    mouseover(items) {
      this.Mode.filter((item) => {
        if (items == item.title) {
          this.Materia = item.title;
          this.MaterialData = this[item.component];
        }
      });
    },
    Signout() {
      window.open(
        "https://sddhht.sdasoft.com.cn/dhty_v2/admin/privilege.php?act=signin&username=" +
          tool.getLocal("username") +
          "&password=" +
          tool.getLocal("password")
      );
    },
    SignoutClick() {
      sessionStorage.clear();
      localStorage.clear();
      // 弹成功提示
      this.$message({
        showClose: true,
        message: "已退出",
        type: "success",
      });
      this.$tab.closeAll();
      this.$router.push("/"); // 跳后端首页
    },
    // 显示/隐藏 主菜单
    showHideMenu(bool) {
      this.showMenu = bool;
    },
    // 岗位 按钮权限
    ButtonPower() {
      tool.removeLocal("Button_Power");
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
      };
      this.request
        .post("/index/Privileges/get_user_group_priv", {
          jparams: JSON.stringify(jparams),
        })
        .then((res) => {
          let { status, data } = res;
          if (status == 0) {
            tool.saveLocal("Button_Power", data);
          }
        });
    },
    // 全屏
    enterFullScreen() {
      let element = this.$refs["right"];
      var requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullScreen;
      // document.body.width = 1920
      // document.body.height = 1080
      requestMethod.call(document.body);
      this.fullScreen = true;
    },
    // 退出全屏
    exitFullScreen() {
      this.fullScreen = false;
      var exitMethod =
        document.exitFullscreen ||
        document.mozCancelFullScreen ||
        document.webkitExitFullscreen ||
        document.msExitFullScreen;
      exitMethod.call(document);
    },
    // 监听 ESC 按键
    listenKeyBoardEvent() {
      let that = this;
      // 监听 ESC 按键
      window.onresize = function () {
        let isFull =
          document.fullscreenEnabled ||
          window.fullScreen ||
          document.webkitIsFullScreen ||
          document.msFullscreenEnabled ||
          false;
        !isFull && that.exitFullScreen();
      };
    },
    // 跳转到对应的应用
    gotoApplication(url) {
      // location.href = url;
      this.$router.push(url); // 跳后端首页
    },
    // 刷新组件
    reFreshTab(item) {
      let c = item.components;
      item.components = [];
      this.$nextTick(() => {
        item.components = c;
      });
    },
    // 打开 页签
    openTab(item) {
      this.searchText = "";
      this.$tab.open(item);
      this.initializeMemu();
    },
    // 搜索菜单
    filterMenu() {
      let that = this;
      this.spreadedMenus = [];
      let keyword = this.searchText;
      let menu = JSON.parse(JSON.stringify(this.config.menu));
      let newMenu = menu.filter((item) => {
        item.sub = item.sub.filter((i) => {
          return i.title.indexOf(keyword) > -1;
        });
        return item.sub.length > 0 && this.spreadedMenus.push(item.menuId);
      });
      this.menuList = newMenu;
    },
    initializeMemu() {
      this.menuList = JSON.parse(JSON.stringify(this.config.menu));
    },
    // 监听hash的变动
    listenHistory() {
      window.addEventListener("hashchange", (e) => {
        let url = location.href;
        let indexOfSharp = url.indexOf("#");
        if (indexOfSharp > 0) {
          let hash = url.substr(indexOfSharp + 2);
          let tab = JSON.parse(Base64.decode(hash));
          if (tab.fromHistory) return;
          tab.fromHistory = true;
          this.$tab.open(tab);
        }
      });
    },
    // 添加收藏某个文件
    addCollect(item) {
      // console.log(item);
    },
    // 删除收藏的某个文件
    removeCollect(item) {
      // console.log(item);
    },
    // getStaffInfo() {
    //   let params = {
    //     command: "1010",
    //     user: {
    //       user_id: tool.getLocal("userid"),
    //       session_id: tool.getLocal("sessionid")
    //     }
    //   };
    //   this.request
    //     .post("http://118.190.210.223:10003/user.php", {
    //       jparams: JSON.stringify(params)
    //     })
    //     .then(res => {
    //       let { command, result, user } = res;
    //       if (result.accept == 1) {
    //         // this.member = user.telephone;
    //       }
    //     });
    // },
    Initialization() {
      var times = Date.parse(new Date());
      var str = times + "e0ee1a3e527abeebc0e2c3e10d90ddbb";
      let a = str.MD5(32); // 32位加密方法
      let jparams = {
        command: "2003",
        user: {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
        },
      };
      this.request
        .post("http://118.190.210.223:10003/user.php", {
          jparams: JSON.stringify(jparams),
        })
        .then((res) => {
          let { companyinfo } = res;
          this.Enterprise = companyinfo.name_ch;
          this.companyinfo = companyinfo.logo_url;
        });
    },
    mouseenter() {
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"),
        Model: "", //用户凭证
      };
      this.request
        .post("/index/Privileges/get_new_user_menu", {
          jparams: JSON.stringify(jparams),
        })
        .then((res) => {
          let { status, JPriv, Priv } = res;
          this.menuList = Priv;
          config.menu = Priv;
          this.ifshow = true;
        });
    },
    IFSGOWclick() {
      this.IfShow = false;
    },
    timesf() {
      var time_end = new Date().getTime(); //(等于系统当前时间)
      var time_start = new Date(tool.getLocal("endtime")).getTime(); //设定结束时间
      var time_distance = time_start - time_end;
      if (time_distance > 0) {
        // 天时分秒换算
        var int_day = Math.floor(time_distance / 86400000);
        time_distance -= int_day * 86400000;
        // 时分秒为单数时、前面加零
        if (int_day < 10) {
          int_day = "0" + int_day;
        }
        if (int_day > 7) {
          this.IfShow = false;
        } else if (int_day < 7) {
          this.IfShow = true;
        }
        this.times = int_day;
      }
    },
    Navigation() {
      this.Mode.filter((item) => {
        let jparams = {
          user_id: tool.getLocal("userid"), //用户id
          session_id: tool.getLocal("sessionid"),
          Model: item.component, //用户凭证
        };
        this.request
          .post("/index/Privileges/get_new_user_menu", {
            jparams: JSON.stringify(jparams),
          })
          .then((res) => {
            let { status, JPriv, Priv } = res;
            this[item.component] = Priv;
          });
      });
    },
    versioninfo() {
      let params = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
      };
      this.request
        .post("/index/Settings/version_info", {
          jparams: JSON.stringify(params),
        })
        .then((res) => {
          // console.log(res);
          this.versioninfog = res.data.AccountLimit;
        });
    },
  },
  mounted() {
    this.$tab.closeAll();
    this.timesf();
    this.mouseenter();
    this.ButtonPower();
    this.Navigation();
    this.versioninfo();
    this.Expire = tool.getLocal("endtime");
    this.ifshow = false;
    this.listenKeyBoardEvent();
    this.Initialization();
    this.initializeMemu();
    // this.time = ;
    // this.city();
  },
  created() {},
  beforeDestroy() {},
};
</script>

<!--公共样式-->
<style>
@import "../../Styles/cover.css";
@import "../../Styles/common.css";
@import "../../Styles/iconfont/iconfont.css";
</style>

<!--私有样式-->
<style scoped>
/* 左侧菜单样式 */
.left_menus {
  width: 80px;
  height: 100%;
  background-color: #091c32;
}
.left_menu {
  width: 80px;
  height: 100%;
  transition: width 0.5s;
  background-color: #091c32;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2000;
  background-color: #071526;
}
.left_menu_hover {
  width: 170px;
  transition: width 0.5s;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2000;
  background-color: #071526;
  overflow: hidden;
}
.jinxiaocun_left_menu12 {
  width: 18px;
  height: 18px;
  margin-left: 26px;
  margin-right: 20px;
}
.jinxiaocun_left_menu123 {
  width: 18px;
  height: 18px;
  margin: -5px 6px 0 -6px;
}
.jinxiaocun_left_menu {
  width: 18px;
  height: 18px;
}
.jinxiaocunclick {
  width: 100%;
  height: 40px;
}
.mouseover_left_menu {
  width: 170px;
  height: 100%;
  font-size: 16px;
  z-index: 101;
  position: relative;
  top: -2px;
  left: -32px;
}
.el-menu-item {
  padding-left: 32px !important;
  height: 40px !important;
  line-height: 40px !important;
  min-width: 80px !important;
  background-color: #071526 !important;
  width: 100%;
}
.el-menu-item:hover {
  background-color: #399cff !important;
}
/*  */
.el-tabs__item {
  height: 32px;
  line-height: 32px;
}
.el-tabs__header {
  margin: 0;
}
.jinxiaocun {
  width: 18px;
  height: 18px;
}
.right_box .el-button--medium {
  padding: 4px 12px;
}
.list_line_style {
  display: flex;
  width: 172px;
  margin: 0 0 20px 0;
}
.el-popper[x-placement^="right"] {
  margin-left: -42px;
  z-index: 4000 !important;
  left: 212px !important;
  /* top: 124px !important; */
}

.el-dropdown-menu--small {
  padding: 0 !important;
}
.Navigation {
  /* width: 700px; */
  /* height: 300px; */
  overflow: hidden;
}
.Navigation .Navigation_box {
  /* width: 718px; */
  /* height: 300px; */
  overflow: auto;
  display: flex;
}

.mouseover {
  width: 200px;
  height: 100%;
  font-size: 16px;
  z-index: 101;
  margin-left: -56px;
  text-indent: 56px;
}
/*总容器*/
.indexWrap {
  min-width: 1200px;
}

/*顶部栏*/
.topWrap {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background: #fff;
  color: #000;
}

/*头部logo*/
.topLogo {
  width: 170px;
  height: 100%;
  background: #fff;
  /* border-right: 1px solid #53a9ff; */
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  box-sizing: border-box;
}

.topLogo-img {
  height: 30px;
}
.topLogoText {
  line-height: 30px;
  font-size: 18px;
  font-weight: bold;
  margin-left: 5px;
}

/*应用选择*/
.appName {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 50px;
  /*background: #0680F9;*/
  background: #0680f9;
  color: #fff;
  border-right: 1px solid #53a9ff;
}

.appName:hover {
  background: #53a9ff;
}

.appNameIcon {
  font-size: 30px;
}

.appSelected {
  color: #fff;
  font-size: 30px;
}

.appItem {
  display: flex;
  align-items: center;
}

.appItem-icon {
  margin-right: 5px;
  font-size: 16px;
}

/*当前项目名称*/
.currentProjectName {
  /* display: flex; */
  padding-left: 15px;
  line-height: 50px;
  font-size: 16px;
}

/*项目选择*/
.projectName {
  padding-right: 10px;
  display: flex;
  align-items: center;
  /* border-right: 1px solid #53a9ff; */
  border-right: 1px solid #ccc;

  /*color: red;*/
}

/*个人信息*/
.userInfoWrap {
  padding-left: 10px;
}

.userInfo {
  margin: 5px 0;
  display: flex;
  align-items: center;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

/*主容器*/
.middleWrap {
  width: 100%;
  height: calc(100vh - 50px);
  overflow: hidden;
  display: flex;
  position: relative;
}

/*主菜单*/
.left {
  width: 80px;
  height: 100%;
  display: block;
  background: #091c32;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
  position: relative;
  box-sizing: border-box;
  flex-shrink: 0;
  z-index: 2000;
  -ms-overflow-style: none;
}

.left::-webkit-scrollbar {
  display: none;
}

/*菜单显示/隐藏 动画*/
.left-enter-active,
.left-leave-active {
  transition: width 0.5s;
}

.left-enter,
.left-leave-to {
  width: 0px;
}
/* 登录时间 */
.footer {
  color: #fff;
  width: 200px;
  height: 32px;
  line-height: 32px;
}
.footer .footer-box {
  font-size: 14px;
  text-align: center;
}
/*搜索和收藏*/
.searchAndFavor {
  padding: 8px 5px 0 5px;
  box-sizing: border-box;
  /* width: 100%; */
  display: flex;
  background: #091c32;
  height: 46px;
}
/* 菜单 */
.content_box {
  width: 100%;
  height: calc(100% - 80px);
  position: absolute;
  top: 0;
  left: 0;
}
.searchiIcon {
  font-size: 20px;
  line-height: 28px;
}

.myFavor {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #2b5992;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.myFavor:hover {
  background: #3d76bc;
}

.myFavorIcon {
  color: #fff;
  font-size: 20px;
  line-height: 28px;
}

/*隐藏菜单 按钮*/
.hideMenuButton {
  width: 12px;
  height: 50px;
  position: relative;
  top: 50%;
  left: -12px;
  transform: translate(0, -50%);

  background: #030a13;
  border-radius: 10px 0 0 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  z-index: 3001;
}

/*显示菜单 按钮*/
.showMenuButton {
  width: 30px;
  height: 300px;
  position: relative;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);

  background: #030a13;
  border-radius: 0px 10px 10px 0px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #fff;
  z-index: 3001;
}

/*显示/隐藏 按鈕 动画*/
.hideMenu-enter-active,
.hideMenu-leave-active {
  transition: all 0.5s;
}

.hideMenu-enter,
.hideMenu-leave-to {
  left: -12px;
}

/*显示/隐藏 按鈕 动画*/
.showMenu-enter-active,
.showMenu-leave-active {
  transition: all 0.5s;
}

.showMenu-enter,
.showMenu-leave-to {
  opacity: 0;
}

/*右侧布局*/
.right {
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-shrink: 1;
  background: #fff;
  border-top: 1px solid #e6e6e6;
}
.fullRight {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  /*border-top: 1px solid #e6e6e6;*/
  z-index: 999;
}

.fullRight .content {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
}

.tabWrap {
  position: relative;
  width: 100%;
}

.tabBar {
  background: #fff;
  height: 36px;
  padding-top: 5px;
  padding-left: 10px;
  box-sizing: border-box;
}

/*以下2个样式,是覆盖 element 下拉菜单的默认样式*/
.elDropdownMenu {
  margin-top: 0 !important;
  padding: 3px 0;
}

/*没有选中的 tab 标签 要隐藏下拉菜单*/
.hiddenDropDown {
  display: none !important;
}

.elDropdownItem:hover {
  background-color: #fff !important;
}

.tabIcon {
  font-size: 20px;
  line-height: 30px;
  box-sizing: border-box;
}

.tabOperate {
  position: absolute;
  width: 30px;
  height: 30px;
  right: 5px;
  top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 3px;
  border: 1px solid #e4e7ed;
}

.tabDropdown {
  display: flex;
  align-items: center;
}

.tabDropdown i {
  font-size: 20px;
  margin-right: 5px;
}

.tabDropdownLine {
  width: 1px;
  height: 16px;
  background: #e4e7ed;
}

.tabDropdownRefresh {
  color: #606266;
  font-size: 14px;
  padding-right: 10px;
  display: flex;
  align-items: center;
}

.tabDropdownRefresh:hover {
  color: #0680f9;
}

.tabDropdownFavor {
  color: #606266;
  font-size: 14px;
  padding-left: 10px;
}

.tabDropdownFavor:hover {
  color: #0680f9;
}

.content {
  width: 100%;
  height: calc(100vh - 100px);
  overflow-y: scroll;
  box-sizing: border-box;
}
.content::-webkit-scrollbar {
  display: none;
}
.home_box {
  position: fixed;
  width: 100%;
  height: 50px;
  background-color: rgba(227, 175, 177, 0.9);
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  color: #fff;
}
.home_box .span {
  line-height: 50px;
  color: #fff;
  text-align: center;
  position: relative;
  left: 40%;
  font-size: 20px;
}

.home_box .i {
  position: relative;
  top: 17px;
  right: 459px;
}
.list_line_tiele {
  font-size: 14px;
}
.list_line_tiele {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  position: relative;
  text-indent: 8px;
}
.list_line_tiele .top_box {
  position: absolute;
  top: 1px;
  left: 193px;
}
.top_box span {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 2px solid #0383fb;
  transform: rotate(46deg);
}
.list_line_tiele .top_box1 {
  position: absolute;
  top: 1px;
  left: 287px;
}
.top_box1 span {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 2px solid #0383fb;
  transform: rotate(46deg);
}
.list-item-box {
  list-style: none;
}
.list-item-box .list_item {
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  margin-right: 12px;
  margin-bottom: 12px;
}
.list-item-box .list_item .item-titles {
  color: #000;
  padding: 0 16px;
  border-radius: 14px;
  margin-bottom: 15px;
}
.list-item-box .list_item .item-title:hover {
  color: #fff;
  padding: 0 16px;
  margin-bottom: 15px;
  background-color: #399cff;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/Views/home/home.vue